/**
 * @todo Notice that `grid.detail` and `gridToPoints.gpgpu.scale` seem linearly
 *   connected to affect performance, probably because `pointsToGrid` tends to
 *   overlap more and cause more blending when the ratio of points to cells is
 *   high...?
 *   In any case, a way to decouple this would be to have a separate set of
 *   tracer points for rendering only that just follow the grid forces, so there
 *   can be more rendered points for the number of material points.
 *
 * @todo Fix grid artefacts:
 * - One clearer cause is `gridToPoints.positionAdjust[1] = 1`;
 *   explore, isolate, identify.
 * - One possible lesser cause is `grid.limit = 1e8`; probably to do with
 *   points crossing cells coinciding with time-step, seems to be helped by
 *   tweaking `passes` higher or lower (higher increases accuracy, lower seems
 *   to let points jump cells).
 */

import { demo, queryState, queryDef } from './demo';

const query = queryDef();
const test = query.get('test');
const report = query.has('report');
const $root = document.documentElement;
const $canvas = $root.querySelector('canvas');

$root.style.background = query.get('background') || '';
$root.style.cursor = query.get('cursor') || '';

query.has('fullscreen') &&
  addEventListener('keyup', (e) => (e.key === 'f') &&
    ((document.fullscreenElement === $canvas)? document.exitFullscreen?.()
    : $canvas.requestFullscreen()));

if(test === 'p2g') {
  const s = $canvas.style;

  s.width = s.height = '100%';
  s.border = '1px dashed red';
  s.margin = 'auto';
  s.imageRendering = 'pixelated';
}

(async () => {
  const mpm = self.mpm = ((test !== 'p2g')? queryState(query) : {
      $canvas,
      pixelRatio: 1,
      api: {
        attributes: { antialias: false }
      },
      head: {
        test: 'test_'+test,
        kernelSize: 1
        // kernelSize: 3
      },
      pointsToGrid: {
        // on: false,
        quads: true,
        framebuffer: null
      },
      grid: {
        on: false,

        // detail: 2e2,
        // detail: 1e2,
        detail: 96,
        // detail: 4,

        limit: 1e8
        // limit: 1e5
        // limit: 96
        // limit: 8
        // limit: 1
      },
      gridToPoints: {
        on: false,
        // gpgpu: { scale: log2(96) }
        // gpgpu: { scale: log2(96/3) }
        // gpgpu: { scale: 4 }
        gpgpu: { scale: 5.1 }
      },
      gridToScreen: { on: false },
      pointsToScreen: { on: false },
      demo: {
        view: [96, 96],
        opticalFlow: { on: false },
        gridFade: { on: false }
      },
      passes: 1
    });

  report && (mpm.onStatus = ({ status: s }, e) =>
    (s !== 'done') && postMessage(`mpm:status:${s} ${e?.message || ''}`, '*'));

  mpm.$canvas = $canvas;
  (await demo(mpm)).demo.start();

  (test === 'p2g') && $canvas.addEventListener('click', () => {
    const { pointsToGrid: pg, gridToScreen: gs } = mpm;

    pg.framebuffer = ((gs.on = !gs.on)? undefined : null);
    console.log('gridToScreen', gs.on);
  });

  return mpm;
})();
